import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DynamicTableService } from '../../services/dynamic-table/dynamic-table.service';
import { AppMainService } from 'src/app/app-main.service';
import { catchError, debounceTime, distinctUntilChanged, map, Observable, of, Subject, Subscription, takeUntil } from 'rxjs';
import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnDefinition, DynamicTableData, EditColumnOrderPayload } from '../../models/dynamic-table/dynamic-table-data.model';
import { DynamicTableColumnFilter, MappedFilter, RowDetails } from '../../models/dynamic-table/dynamic-table-column.model'
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { FilterLine, RetainSavedFilterData, SavedFilterData } from '../../models/dynamic-table/dynamic-table-filter.modal';
import { DynamicTableFormService } from '../../services/dynamic-table/dynamic-table-form.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ChatBotModule } from 'src/app/modules/shared/components/chatbot-modal/model/chatbot.model'
import { WorkbookList } from 'src/app/misc/workspace/models/workspace.models';
import { WorkspaceService } from 'src/app/misc/workspace/services/workspace.service';
import { AccountModuleId, workspaceModuleId, workspaceModuleName } from '../../constants/modules.constant';
import { WbAttachmentsDocument, WbAttachmentsDownload, WbEditAttachmentsPayload } from '../../models/dynamic-table/dynamic-table-document.model';
import { WorkbookReminderInputProps } from 'src/app/misc/workspace/models/workbook-reminder.models';
import { environment } from 'src/environments/environment';
import { ColumnSettingsN, SectionN } from '../../models/column-settings.model';
import { alphaNumericValidator } from '../../validators/alpha-numeric.validator';
import { FormControlList, FormControlListIds } from '../../constants/formcontrol-list.constants';
import { FormErrorHandler } from '../../helpers/form-error-handler.helper';
import { ImportserialService } from '../../services/importserial.service';
import { DocumentViewerService } from '../../services/document-viewer.service';
import { noWhiteSpaceValidator, trimFirstWhiteSpaces } from '../../validators/trim-white-spaces.validator';
import { WBPermissionType } from 'src/app/misc/workspace/enum/workbook-permission.enum';
import { TimeZoneService } from '../../services/timezone.service';
import { filterDateRangeHelper } from '../../helpers/filter-date-range.helper';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { StatusBarResponse, StepBarResponse } from 'src/app/misc/workspace/modals/stepbar.models';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrl: './dynamic-table.component.scss'
})

export class DynamicTableComponent implements OnInit, OnChanges {
   envName = environment?.envName||'';
  /** Input/References */
  @Input() workbookId?: string;
  @Input() showBreadcrumb;
  @Input() isHideSide;
  @Input() breadcrumbItems;
  @Input() showFloatHead?: boolean = false; //Use to detect change in table header.
  @Input() selectedWorkbook: WorkbookList
  @Input() workspaceName: string;
  @Input() isCustomModule: boolean = false;
  @Input() isShowSideBtn: boolean = false;
  @Input() isSubModuleWidgets: boolean = false;
  @Output() workbookPropertyChanged? = new EventEmitter<{ isUpdate: boolean }>();
  @Output() isChangeSideBtn = new EventEmitter<boolean>();
  @ViewChild('newtable') table: Table;
  forceReflow: boolean = false;
  showFloatHeader: boolean = false;

  /** Subscription and Cleanup */
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  /** Identifiers */
  workspaceId: string;

  /** Table Data */
  workbookRows: RowDetails[] = [];
  workbookColumns: ColumnDefinition[] = [];
  tempWorkBookColumns: ColumnDefinition[] = [];
  dynamicTableData: DynamicTableData;

  /**table name */
  tableName: string = ''
  isEditHeader = false;
  isUpdating: boolean = false;  // To prevent multiple API hits
  validationErrors:Object = {};  // To store validation error messages

  /** Column Filters */
  mappedColFilter: DynamicTableColumnFilter[] = [];
  globalFilterFields: string[] = [];
  filterInColumns: MappedFilter[];
  saveFilterData: SavedFilterData;
  highestColumnOrder: number = 0;
  allListColumns: SectionN[] = [];
  displayExport: boolean = false;

  /**Group BY */
  selectedGroupBy: any = null;
  selectedGroupByValue: any = null;
  groupByColumn: any = null;
  groupAllExpanded: boolean = false;
  groupWorkBookRows: any[] = []
  isGrouped: boolean = false;

  /** Column and Row Selection */
  selectedRow: any;
  columnMenuIndex: number = 1;
  columnForm: FormGroup;
  selectedSortColumn: { name: string; dataType: string } | null = null;
  selectedColumn: ColumnDefinition;

  /** Pagination */
  pageNumber: number = 1;
  pageSize: number = 15;
  totalRecords: number = 0;
  tableShowMore: number[] = [15, 30, 50, 100];
  first: number = 0;
  rows: number = 0;
  //GroubBy Pagination
  rootPageSize: number = 15;
  rootPageNumber: number = 1;

  /** Global Search */
  globalSearchValue: string = "";
  globalSearchValueControl = new FormControl();

  /** Sorting */
  isDescending: boolean = null;

  /** Context Menu */
  contextMenuItems!: MenuItem[];

  /** Add-edit-form */
  displayAddEdit: boolean = false;
  mode: string;
  formHeader: string;
  currentRowNUmber: number;

  /** Add-worbook-dynamic-form */
  displayDynamicForm: boolean = false;
  dynamicFormID: string;
  shareLink: string
  dynamicFormData: any[]= [];

  //Add to Widget
  displayAddToList = false;
  displayAddedList = false;
  tabList: any = [];
  workBookList: any[] = [];

  //** Import workbook rows */
  displayImport: boolean = false
  workspaceModuleId: number = workspaceModuleId


  /** Column Related */
  barcodeTypes: { name: string, value: string }[] = [
    { name: 'CODE128', value: 'CODE128'}];
  displayAddExpression:boolean = false;
  availableFieldsForExpression: any[] = [];
  expressionText: string = "";


  /** Miscellaneous */
  dataTypes: any;
  dataTypesValidation:any;
  formControlNameAvailable = ['Number', 'Decimal', 'InputBox', 'DatePicker', 'DropDownList', 'DateTimePicker', 'Percentage']; //Formcontrol.
  deletedColumnOptions: any[] = [];
  displayEditColumn: boolean = false;
  displayAddColumn: boolean = false;
  formLinks: any = [];

  /**Menu Items */
  menuItems: MenuItem = [];
  displayPredict = false;
  displayChatBox: boolean = false;
  rowGroupMetadata: any;

  /** Attachments */
  attachmentHeader: string = 'Attachments';
  displayAttachment = false;
  uploadedFiles: any;
  documentsList: WbAttachmentsDocument[] = [];
  selectedWorkbookRow: any;
  documentCMItems: MenuItem[] = [];
  selectedDocument: WbAttachmentsDocument;
  displayFilePreview: boolean = false;
  currentFile: any;
  displayEditDocument: boolean = false;
  tempDocument: WbAttachmentsDocument;
  tempDocumentName: string;
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.txt', '.xls', '.xlsx', '.csv', '.doc', '.docx', '.ppt', '.pptx', '.pdf'];
  allowedExtensionsAccept = this.allowedExtensions.join(',');
  tooltipText =  `Notes:
  1. Allowed file extensions: ${this.allowedExtensionsAccept}.
  2. Maximum upload size for a file is 10MB.`;

  /** Comments */
  displayComments: boolean = false;
  updateReadStatus: boolean = false;

  /** Reminder */
  displayReminder: boolean = false;
  workbookReminderProps: WorkbookReminderInputProps;

   /**Column settings */
 columnSettingsN: Partial<ColumnSettingsN> = {};
 displayColumnSettings: boolean = false;
 disabledLabelNames: string[] = [];
 fromUpdateSettings: boolean = false;
 selectedView: string = 'list';
 workspaceModuleName: string = workspaceModuleName;
 columnSettings: any[]=[];
 kanbanViewColumns: ColumnDefinition[]=[];
 /**User Detail pop up */
 displayUserDetails: boolean = false;
 selectedUser: any;

 detailsFormErrors: any = {};
 formErrorHandler: FormErrorHandler = new FormErrorHandler();
 currencies:any[] = [];

 //files and pics
 displayFileDialog: boolean = false;
 displayType: 'files' | 'pics' = 'files';
 displayItems: any[] = [];
 
 WBPermissionType = WBPermissionType;

  /** Convert To Different Module Object*/
  displayConvertToDifferentModule: boolean = false;
  accountmoduleId: number = AccountModuleId;
  isCopyMoveWBRow: boolean = false;
  isCopyWBRow: boolean = false;
  isMoveWBRow: boolean = false;
  isCreateDuplicateRow: boolean = false;

  /**Different Views */
  viewType: 'ListView' | 'KanbanView' = 'ListView';
  kanbanGroupByColumn: string = '';
  kanbanCardTitleColumn: string = '';
  kanbanCardContentColumns: string[] = [];

  defaultViewType: string;
  statusBarData: StatusBarResponse;
  stepBarFilter: any = null;
  steps: StepBarResponse[] = [];

  /**Bulk Delete */
  displayBulkDelete: boolean = false;
  @ViewChild('sharedWorkbookListing') sharedWorkbookListing;

  private routeSubscription: Subscription;

  constructor(public dynamicTableService: DynamicTableService,
    public dynamicTableFormService: DynamicTableFormService,
    private readonly appMainService: AppMainService,
    private readonly route: ActivatedRoute,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    private readonly fb: FormBuilder,
    public app: AppMainComponent,
    private readonly router: Router,
    private readonly workspaceService: WorkspaceService,
    private readonly importService: ImportserialService,
    private readonly documentViewerService: DocumentViewerService,
    private timeZoneService: TimeZoneService,
  ) {
    this.route.params.subscribe((params) => {
      this.workspaceId = params['id'];
      this.workbookId = params['workbookId'];
    });
  }
  /**Initializing data, and handling changes. */
  ngOnInit() {
    this.getFormcontrolType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['workbookId'] && !this.isCustomModule) {
      this.ResetVariablesState();
      if (this.table) {
        this.resetpageState();
      }
      this.initializeComponent();
    }

    if (changes['workbookId'] && this.isCustomModule) {
      this.getWorkbookDetails();
    }

    if (changes['selectedWorkbook']) {
      this.tableName = this.selectedWorkbook?.name;
      this.updateDynamicFormsLinks(this.dynamicFormData);
      this.updateTabListMenu();
      this.setupContextMenu();
    }

    if (changes['showFloatHead']) {
      this.forceReflow = !this.forceReflow;
    }

    if (changes.workspaceName && changes.workspaceName.currentValue) {
      this.workspaceName = changes.workspaceName.currentValue;
    }

  }

  ResetVariablesState(){
    this.isGrouped = false;
    this.selectedGroupBy = null;
    this.selectedGroupByValue = null;
    this.isEditHeader = false;
    this.kanbanViewColumns = [];
    this.columnSettings = [];
    this.steps = [];
    this.filterInColumns = [];
    this.stepBarFilter = null;
    this.saveFilterData = {};
  }

  resetpageState() {
    if (this.table) {
      this.table.reset(); // This will reset the pagination and sorting
    }
    this.rootPageNumber = 1;
    this.rootPageSize = 15;
    this.pageNumber = 1;
    this.pageSize = 15;
    this.totalRecords = 0;
    this.first = 0;
  }

  initializeComponent() {
    // this.getDynamicTableColumn(this.workbookId);
    this.getWorkbookColumnSetting(this.workbookId);
    this.getDynamicFormsByWorkbookID(this.workbookId);
    // this.setupContextMenu();
    // this.initWorkbookColumnForm();
    this.searchWorkbookwithQuery();
  }

  buildMenu() {
    this.menuItems = [
      {
        label: "Tools",
        // icon: "pi pi-cog",
        items: this.buildAdvancedMenuItems(),
      },
      {
        label: "Action",
        // icon: "pi pi-angle-down",
        items: this.tabList,
      },
    ];
  }

  buildAdvancedMenuItems() {
    const advancedMenuItems = [];
    const hasReadPermission = this.selectedWorkbook?.permissionType >= WBPermissionType.Read;
    const hasReadWritePermission = this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite;

    if (hasReadPermission) {
      advancedMenuItems.push({
        label: 'Dynamic Charts',
        icon: 'pi pi-chart-bar',
        command: () => this.showDynamicCharts()
      });
    }

    if (hasReadPermission) {
      advancedMenuItems.push({
        label: 'Predict/Forecast',
        icon: 'pi pi-chart-line',
        command: () => this.displayPredict = true
      });
    }

    if (hasReadPermission) {
      advancedMenuItems.push({
        label: 'Chat',
        icon: 'pi pi-comments',
        command: () => this.showWorkbookChatBox()
      });
    }

    if (hasReadPermission) {
      const widgetSubItems = [];
      
      if (this.selectedWorkbook?.isWidgetAvailable) {
        widgetSubItems.push(
          {
            label: 'View Added Widget',
            icon: 'pi pi-eye',
            command: () => {
              this.viewAddedList();
            }
          },
          {
            label: 'Add New Widget',
            icon: 'pi pi-plus',
            command: () => {
              this.addToList();
            }
          }
        );
      }
      else {
        widgetSubItems.push(
          {
            label: 'Add to Widget',
            icon: 'pi pi-plus',
            command: () => {
              this.addToList();
            }
          }
        );
      }
      
      advancedMenuItems.push({
        label: 'Widget',
        icon: 'pi pi-th-large',
        items: widgetSubItems
      });
    }

    // Forms menu - ReadWrite permission required
    if (hasReadWritePermission) {
      advancedMenuItems.push({
        label: 'Forms',
        icon: 'pi pi-align-left',
        items: this.formLinks,
      });
    }
    return advancedMenuItems;
  }

  navigateToBack() {
    this.router.navigate([`/workspace/${this.workspaceId}`]);
  }

  //#region Context MENU
  setupContextMenu() {
    this.contextMenuItems = [
      this.selectedWorkbook?.permissionType >= WBPermissionType.Read && {
        label: 'View',
        icon: 'pi pi-eye',
        command: () => this.onRowSelect(event),
      },
      this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite && {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => this.openEditDialog(),
      },
      this.selectedWorkbook?.permissionType === WBPermissionType.AllAccess && {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => this.openDeleteDialog(),
      },
      this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite && {
        label: 'Convert to Other Module',
        icon: 'pi pi-sync',
        command: () => this.convertToOtherModuleObject(true),
      },
      this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite && {
        label: 'Move Row',
        icon: 'pi pi-forward',
        command: () => this.moveToOtherWorkbook(true),
      },
      this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite && {
        label: 'Copy Row',
        icon: 'pi pi-copy',
        command: () => this.copyToOtherWorkbook(true),
      },
      this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite && {
        label: 'Duplicate Row',
        icon: 'pi pi-copy',
        command: () => this.createDuplicateRow(true),
      },
    ].filter(Boolean); // Remove null items to keep the menu clean
  }

  showWorkbookChatBox() {
    if (this.workbookId != this.app.chatBotInitializationData?.workbookId) {
      this.app.chatBotInitializationData = {
        workbookId: this.workbookId,
        sessionId: null
      }
    }

    this.app.chatbotModule = ChatBotModule.WorkBook;
    this.app.chatbotModules.push(ChatBotModule.WorkBook);
    this.app.selectedChatbotWindow = ChatBotModule.WorkBook;
    this.app.displayChatBox = true;
  }
  //#endregion Context MENU

  //#region Predict/Forecast
  openPredict() {
    this.displayPredict = true;
  }
  closePredict() {
    this.displayPredict = false;
  }
  //#end region Predict/Forecast

  initWorkbookColumnForm() {
    this.columnForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(128)]],// Name of the column
      formControlId: [null],   // Form control ID (required for both add/edit)
      formControlName: [{ value: '', disabled: false }, [Validators.required]], // Disable later in edit mode
      isFrozen: [false],                            // Boolean for frozen state
      id: [null],
      options: this.fb.array([]),
      updateOptions: this.fb.array([]), // For pre-existing options // Column ID, useful for edit mode
      type: [null], //Barcode Type
      expression: [''],
      prefix: ['', [Validators.maxLength(3), alphaNumericValidator()]],
      startNumber: [null],
      // endingSequenceNumber: [null],
      maxLengthAfterDecimal: [null, [Validators.min(1), Validators.max(6)]],
      displayLength: [null],
      maxDecimalPlaces: [2, []],
      currencyId: [null],
    });
    this.subscribeToFormChanges();
    this.formErrorHandler.handleErrors(this.columnForm, this.detailsFormErrors, {
      type: {
          required: 'Select any barcode type'
      },
      prefix: {
          required: 'Enter auto number prefix',
          alphaNumeric: 'Only alphabets, numbers, spaces, hyphens, and underscores are allowed.'
      }
  });
    if (this.displayAddColumn) {
      this.columnForm.get('formControlName').valueChanges.subscribe(value => {
        if (value?.name === 'DropDownList'||value?.name === 'MultipleDropDownList'||value?.name === 'CheckBox'||value?.name === 'RadioButton') {
          this.addOption(); // Ensure at least one option is present
        } else {
          this.clearOptions();
        }
      });
    }
    this.loadCurrencies();
  }

  loadCurrencies(): void {
    this.importService.getOrgCurrency().subscribe(value => {
        if (value) {
            this.currencies = value;
            const activeCurrencies = this.currencies.filter(currency => currency?.statusId === 1);
            this.currencies = activeCurrencies.map((currency) => {
                return {
                    id: currency.currencyId,
                    name: `${currency.name} - ${currency.code}`
                };

            });
        }
    })
}
  get hasRows(): boolean {
    return this.isGrouped ? this.groupWorkBookRows?.length > 0 : this.workbookRows?.length > 0;
  }

  // Separate FormArray for `updateOptions`
  get updateOptions(): FormArray {
    return this.columnForm.get('updateOptions') as FormArray;
  }

  subscribeToFormChanges() {
    this.columnForm.get('formControlName')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((selectedType) => {
      if (selectedType) {
        this.applyValidations(selectedType.id);
      }
    });

  }

  applyValidations(fieldId: number = 0) {
    const formControlId = fieldId || this.columnForm.value.formControlName?.id || 0;
    const validations = {
      type: [],
      prefix: [],
      startNumber: [],
      // endingSequenceNumber: [],
      expression: [],
      displayLength: [],
      currencyId: [],
      maxDecimalPlaces: []
    };

    switch (formControlId) {
      case FormControlListIds.AutoNumber:
        validations.prefix = [Validators.maxLength(3), alphaNumericValidator()];
        validations.startNumber = [Validators.required];
        // validations.endingSequenceNumber = [Validators.required];
        break;
      case FormControlListIds.Barcode:
        validations.type = [Validators.required];
        break;
      case FormControlListIds.EncryptedText:
        validations.displayLength = [Validators.required, Validators.min(0), Validators.max(10)];
        break;
      case FormControlListIds.Currency:
        validations.currencyId = [Validators.required];
        break;
      case FormControlListIds.Formula:
        validations.expression = [Validators.required];
        break;
        case FormControlListIds.Decimal:
          validations.maxDecimalPlaces = [Validators.required, Validators.min(1), Validators.max(10)];
      break;
    }

    Object.keys(validations).forEach((key) => {
      this.columnForm.controls[key].setValidators(validations[key]);
      this.columnForm.controls[key].updateValueAndValidity();
    });
  }
  isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  // Populate `updateOptions` with pre-existing data
  patchUpdateOptions(updateOptionsData: any[]) {
    const updateOptionsArray = this.fb.array(
      updateOptionsData.map(option =>
        this.fb.group({
          id: [option?.id],
          option: [option?.value, [Validators.required, Validators.maxLength(500), noWhiteSpaceValidator,trimFirstWhiteSpaces]],
          color: [option?.color|| '#7FFFD4', [ this.colorValidator()]],
          order: [option?.order]
        })
      )
    );
    this.columnForm.setControl('updateOptions', updateOptionsArray);
  }


  noLeadingSpaceValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    if (value.startsWith(' ')) {
      return { leadingSpace: true };
    }
    return null;
  }

  // Validator to prevent special characters
  noSpecialCharactersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const specialCharsRegex = /[!%^&*,~?":{}|<>]/g;  // Regex for special characters
    if (specialCharsRegex.test(value)) {
      return { specialCharacter: true };
    }
    return null;
  }

  // Get the FormArray
  get options(): FormArray {
    return this.columnForm.get('options') as FormArray;
  }

  // Add a new option
  addOption(): void {
    const optionGroup = this.fb.group({
      option: ['', [Validators.required, Validators.maxLength(500), noWhiteSpaceValidator,trimFirstWhiteSpaces]],// Name field
      color: ['#7FFFD4', [Validators.required, this.colorValidator()]], // Color picker field
      order: [this.options.length + 1]
    });
    this.options.push(optionGroup);
    this.options.updateValueAndValidity();
  }

  // Remove an option
  removeOption(index: number): void {
    this.options.removeAt(index);
  }

  removeExistingOption(index, option){
    this.updateOptions.removeAt(index);
    this.deletedColumnOptions.push(option.value.id);
  }
  // Clear all options
  clearOptions(): void {
    this.options.clear();
  }

  // Custom validator for color input
  colorValidator() {
    return (control: any) => {
      const value = control.value;
      return value && value.trim() ? null : { required: true };
    };
  }


  // The main method to map table data.
  tableMapper(dynamicTableData: DynamicTableData): void {
    // const newColumnData = this.mapColumns(dynamicTableData?.columnDefinition);
    const mappedData = this.mapRows(dynamicTableData?.result?.list);
    const sortedColumns = this.sortFrozenColumns(this.workbookColumns);
    this.updateTableData(sortedColumns, mappedData);
  }

  tableMapperForGroupBy(dynamicTableData: any): void {
    const mappedData = this.mapGroupedRows(dynamicTableData?.result?.list);
    const sortedColumns = this.sortFrozenColumns(this.workbookColumns);
    this.groupWorkBookRows = mappedData;
    this.isGrouped = true;
    if (!this.isGrouped) {
      this.workbookColumns = [...sortedColumns];
    }
  }

  mapGroupedRows(groupedData: any[]): any[] {
    return groupedData.map(group => {
      // Call mapRows for each list of rows within the group
      const mappedRows = this.mapRows(group.Data); // Apply mapRows at each index of the data
      return {
        groupCount: group.GroupCount,  // Store the group count
        groupValue: [FormControlList.MultipleDropDownList, FormControlList.FileUpload, FormControlList.Picture,FormControlList.CheckBox, FormControlList.Formula, FormControlList.UserLookup].includes(this.selectedGroupBy?.formControlType)&& group.GroupValue? this.safeJsonParse(group.GroupValue): group.GroupValue, // Store the group value if applicable
        rowList: mappedRows  // Mapped rows for the current group
      };
    });
  }

  // Method to map workbookRows from result.list
  mapRows(rowList: any[]): any[] {
    return rowList.map(row => {
      const rowData = {};
      row.Cells.forEach(cell => {
        const column = this.workbookColumns.find(col => col?.id === cell?.ColumnId);
        rowData[cell.ColumnId] = {
          value:[FormControlListIds.MultipleDropDownList, FormControlListIds.FileUpload, FormControlListIds.Picture,FormControlListIds.CheckBox, FormControlListIds.Formula, FormControlListIds.UserLookup].includes(column?.formControlId)&& cell.Value? this.safeJsonParse(cell.Value): cell.Value,
          color: cell.Color,
          textColor: cell.TextColor,

        };
      });
      return {
        RowNumber: row.RowNumber,
        rowData: rowData,
        readStatus: row.ReadStatus,
        noOfComments: row.NoOfComments,
        noOfUnreadComments : row.NoOfUnreadComments,
        noOfDocument: row.NoOfDocument,
        noOfUpcomingReminder: row.NoOfUpcomingReminder,
      };
    });
  }

  safeJsonParse(value: any): any {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value; // Return as is if parsing fails
    }
  }
  // Method to update the workbook rows and column
  updateTableData(columns: ColumnDefinition[], workbookRows: any[]): void {
    this.workbookColumns = [...columns];
    this.workbookRows = [...workbookRows];
  }

  /**Sorting */
  // Method to sort columns based on isFrozen and order properties
  sortFrozenColumns(columns: any[]): any[] {
    this.highestColumnOrder = 0;
    const frozenColumns = columns.filter((col) => col.isFrozen).sort((a, b) => a.displayOrder - b.displayOrder);
    const unfrozenColumns = columns.filter((col) => !col.isFrozen).sort((a, b) => a.displayOrder - b.displayOrder);
    if(columns?.length>0){
      this.highestColumnOrder = Math.max(
        ...columns.map((col) => col.order)
      ) + 1;
    }

    return [...frozenColumns, ...unfrozenColumns];
  }

  toggleSortColumn(menu, curCol) {
    // Check if the column is already selected and toggle the sort order
    if (this.selectedSortColumn?.name === curCol?.name) {
      this.isDescending = !this.isDescending; // Toggle the sort order
    } else {
      this.selectedSortColumn = { name: curCol.name, dataType: curCol.dataType }; // Set new column
      this.isDescending = false; // Default to ascending order
    }

    // Apply the sorting logic (ascending or descending)
    this.sortColumn(menu, curCol, this.isDescending ? 'desc' : 'asc');
  }

  sortColumn(menu, curCol, sortOrder) {
    menu.hide(); // Hide menu after sorting
    this.selectedSortColumn = { name: curCol.name, dataType: curCol.dataType };
    this.isDescending = sortOrder === 'desc';
    this.resetpageState();
    // this.getFilteredDynamicTable(); // Refresh the table
  }

  mapColsToFilters(workbookColumns: ColumnDefinition[]): DynamicTableColumnFilter[] {
    return workbookColumns
    .filter(col => col.enable && ![FormControlList.FileUpload,FormControlList.Picture, FormControlList.EncryptedText, FormControlList.MultiLine, FormControlList.RichText].includes(col.formControlName))
    .map(col => ({
      id: col.id, // Assuming 'id' is a string in ColumnDefinition, converting to number
      name: col.name,
      systemGeneratedName: col.name, // Mapping 'name' from ColumnDefinition to 'systemGeneratedName'
      columnName: col.name, // Assuming 'name' in ColumnDefinition is the columnName
      dragable: true, // Setting default true,
      enabled: col.enable,
      isRequired: false,
      displayOrder: col.order,
      isCustom: true,
      mapObject: null,
      fieldDataType: col.dataType,
      formControlType: col.formControlName,
      maxLengthAfterDecimal: null,
      isDateWithTime: false,
      customAttributeObjectId: null,
      operators: col.searchOperators, // Mapping operators directly
      pickListValues: [],
      isDisabled: null,
      childFields: [],
      valueList: [],
      value: '',
      groupByColumnName: col.name,
      isGroupByColumnCSV: false
    }));
  }
  getEnabledColumnNames(columns: ColumnDefinition[]): { name: string }[] {
    return columns.filter(col => col?.enable).map(col => ({ name: col?.name }));
  }

  /** Filtering */
  applyFilters(event) {
    if (!event.selectedFilter) {
      this.filterInColumns = [];
      this.saveFilterData = { "groupByFieldId": null, "groupByColumnName": null, "filter": [] };
      this.saveFilterDataChannalWise(this.saveFilterData);
      if (this.isGrouped) {
        this.getGroupByDynamicTable();
      } else {
      this.getFilteredDynamicTable();
      }
      return
    }
    this.saveFilterData = {
      "groupByFieldId": null, "groupByColumnName": null, "filter": event?.selectedColumnsForSaveFilterFieldsChannelWise
    };
    this.filterInColumns = this.mapFilterDetails(event.selectedFilter);
    this.resetpageState();
    this.saveFilterDataChannalWise(this.saveFilterData);
  }

  getDataTypeByName(columnName: string): string | null {
    const column = this.workbookColumns.find(col => col.name === columnName);
    return column ? column.formControlName : null;
  }

  buildFilterQuery() {
    const selectableColumns = this.getEnabledColumnNames(this.workbookColumns);
    const filterInColumns = [...this.filterInColumns];
    if (this.stepBarFilter) {
      filterInColumns.push(this.stepBarFilter);
      // If stepBarFilter column is not in selectableColumns, push it
      const stepBarColName = this.stepBarFilter?.name || this.statusBarData?.columnName;
      if (stepBarColName && !selectableColumns.some(col => col.name === stepBarColName)) {
        selectableColumns.push({ name: stepBarColName });
      }
    }
    // Build the final filter query object
    const filterQuery = {
      globalSearchValue: this.globalSearchValue || '',
      tableId: this.workbookId,
      pageNumber: this.pageNumber || 1,  // Default to first page if not specified
      pageSize: this.pageSize || 15,  // Default to current pageSize
      selectableColumns: selectableColumns,
      ...(filterInColumns? { filterInColumns: filterInColumns} : {}),
      ...(this.selectedSortColumn ? { sortByColumn: this.selectedSortColumn } : {}),
      ...(this.isDescending !== undefined && this.isDescending !== null ? { isDescending: this.isDescending } : {}),
    };

    return filterQuery;
  }

  buildGroupByQuery() {
    const selectableColumns = this.getEnabledColumnNames(this.workbookColumns);
    const selectedGroupColumn = this.getColumnNameByID(this.selectedGroupBy?.id);
    // Build the final filter query object
    const filterQuery = {
      globalSearchValue: this.globalSearchValue || '',
      tableId: this.workbookId,
      pageNumber: this.rootPageNumber || 1,  // Default to first page if not specified
      pageSize: this.rootPageSize || 15,  // Default to current pageSize
      selectableColumns: selectableColumns,
      formControlName: selectedGroupColumn?.formControlName,
      rootPageSize: this.pageSize || 15,
      rootPageNumber: this.pageNumber || 1,
      ...(this.filterInColumns ? { filterInColumns: this.filterInColumns } : {}),
      ...(this.selectedSortColumn ? { sortByColumn: this.selectedSortColumn } : {}),
      ...(this.isDescending !== undefined && this.isDescending !== null ? { isDescending: this.isDescending } : {}),
      ...(this.selectedGroupBy ? { groupByColumn: { name: this.selectedGroupBy?.name, dataType: this.selectedGroupBy?.fieldDataType } } : {})
    };

    return filterQuery;
  }

  mapFilterDetails(filterDetails: any[]): MappedFilter[] {
    // If filterDetails is null or undefined, return an empty array
    if (!filterDetails) {
      return [];
    }
    // Map the filterDetails only if it's not null
    return filterDetails.map(detail => {
      const dataType = this.getDataTypeByName(detail.name);
      let field: MappedFilter = {
        name: detail?.name,
        dataType: dataType,
        operationType: detail?.operationType,
        operator: detail?.operator,
        values: []
      };

      if (detail.operator === "On" || detail.operator === "NotOn") {
        const filterData = {
          columnName: detail.name,
          operator: detail.operator,
          operationType: detail.operationType,
          values: detail.values,
          isCustom: true
        };
        field = this.dateOnOperatorListValue(filterData, field);
      } else {
        field.values = detail?.values || [];
      }

      return field;
    });
  }

  /** Fetch workbook and API request */

  getFormcontrolType() {
    this.appMainService.isShowSpinner('getFormcontrolType');
    this.dynamicTableService.getFormcontrolType()
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        // map((response: any[]) =>
        //   response.filter(item => {
        //     const isFormcontrolIncluded = this.formControlNameAvailable.includes(item?.name);
        //     return isFormcontrolIncluded;
        //   }
        //   )
        // )
      )
      .subscribe({
        next: (response: any[]) => {
          this.appMainService.isHideSpinner('getFormcontrolType');
          this.dataTypes = response.sort((a, b) =>
            (a?.label || a?.name).localeCompare(b?.label || b?.name)
          );
          this.dataTypesValidation = response.map(item => {
            return {
              name: item.name,
              id: item.id,
              validationRegex: item.validationRegex,
            }
          }); // Filter out the form control types
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getFormcontrolType');
        }
      });
  }


  getFilteredDynamicTable() {
    const filterQuery: any = this.buildFilterQuery();
    this.appMainService.isShowSpinner('getFilteredDynamicTable');
    this.dynamicTableService.getFilteredDynamicTable(filterQuery).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: DynamicTableData) => {
        this.appMainService.isHideSpinner('getFilteredDynamicTable');
        this.dynamicTableData = JSON.parse(JSON.stringify(response));
        this.tableName = this.dynamicTableData?.name;
        this.showFloatHeader = true;
        this.forceReflow = !this.forceReflow;
        this.tableMapper(this.dynamicTableData);
        this.totalRecords = this.dynamicTableData?.result?.totalNumberOfRows;
        // if (!this.filterInColumns?.length) {
        //   this.mappedColFilter = this.mapColsToFilters(this.workbookColumns);
        // }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getFilteredDynamicTable');
      }
    })
  }

  getGroupByDynamicTable() {
    const groupByQuery: any = this.buildGroupByQuery();
    this.appMainService.isShowSpinner('getGroupByDynamicTable');
    this.dynamicTableService.getGroupByDynamicTable(groupByQuery).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('getGroupByDynamicTable');
        this.dynamicTableData = response;
        this.totalRecords = this.dynamicTableData.result.totalNumberOfRows;
        this.tableMapperForGroupBy(this.dynamicTableData);
        // if (!this.filterInColumns?.length) {
        //   this.mappedColFilter = this.mapColsToFilters(this.workbookColumns);
        // }
      },
      error: (error) => {
        this.isGrouped = false;
        this.appMainService.isHideSpinner('getGroupByDynamicTable');
      }
    })
  }


  searchWorkbookwithQuery() {
    this.globalSearchValueControl.valueChanges.pipe(
      debounceTime(700),
      distinctUntilChanged())
      .subscribe((value: string) => {
        this.globalSearchValue = value.trim() || '';
        this.resetpageState();
        // this.getFilteredDynamicTable()
      });
  }

  getWorkbookDetails(){
    this.appMainService.isShowSpinner('getWorkbookDetails');
    this.dynamicTableService.getWorkbookDetailsById(this.workbookId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('getWorkbookDetails');
        this.workbookId = response?.id;
        this.resetpageState();
        this.ResetVariablesState();
        this.selectedWorkbook = response;
        this.workspaceId = response?.workspaceGuid;
        this.tableName = response?.workbookName;
        this.setupContextMenu();
        this.initializeComponent();
        this.updateTabListMenu();
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getWorkbookDetails');
      }
    })
  }

  getDynamicTableColumn(tableId: string) {
    this.appMainService.isShowSpinner('getDynamicTableColumn');
    this.dynamicTableService.getDynamicTableColumn(tableId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: ColumnDefinition[]) => {
        this.appMainService.isHideSpinner('getDynamicTableColumn');
        const sortedColumns = this.sortFrozenColumns(response);
        this.workbookColumns = [...sortedColumns];
        this.mappedColFilter = this.mapColsToFilters(this.workbookColumns);
        this.allListColumns = this.mapWorkbookColumnDefinitions(response||[]);
        this.getFilterData();

      },
      error: (error) => {
        this.appMainService.isHideSpinner('getDynamicTableColumn');
      }
    })
  }

  getWorkbookColumnSetting(tableId: string) {
    this.appMainService.isShowSpinner('getWorkbookColumnSetting');
    this.dynamicTableService.getWorkbookColumnSettings(tableId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('getWorkbookColumnSetting');
        this.columnSettings = response?.columnSettings;
        const column = response?.columnSettings.find(col => col.viewType==='ListView');
        const colSettingResponse = this.getColumnSettingFlatList(column?.columnSetting);
        const sortedColumns = this.sortFrozenColumns(colSettingResponse);
        this.workbookColumns = [...sortedColumns];
        const kanbanViewColumns =response?.columnSettings.find(col => col.viewType==='KanbanView');
        const kanbanViewFlatList = this.getColumnSettingFlatList(kanbanViewColumns?.columnSetting);
        this.kanbanViewColumns = structuredClone(kanbanViewFlatList);
        this.mappedColFilter = this.mapColsToFilters(this.workbookColumns);
        this.allListColumns = this.mapWorkbookColumnDefinitions(colSettingResponse||[]); 
        this.statusBarData = response?.stepbarStatus;
        this.loadStepBar(response?.stepbar?.stepBarList);
        this.setDefaultViewType(response?.defaultViewType as 'ListView' | 'KanbanView');
        this.getFilterData();
        // this.getFilteredDynamicTable();
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getWorkbookColumnSetting');
      }
    })
  }

  getColumnSettingFlatList(column): any[] {
    return column.map(col => {
      const { id, displayOrder, enable, dragable, columnDefinition, columnSettingId } = col;
      return {
        ...columnDefinition,
        colSettingId: id,
        displayOrder,
        enable,
        dragable,
        columnSettingId: columnSettingId,
      };
    });
  }

  mapWorkbookColumnSettings(columnDefinitions: any[]): any[] {
    return [
        {
        customFields: [],
        fields: columnDefinitions.map((col) => ({
            id: col.colSettingId,
            name: col.name,
            labelName: col.name,
            field: col.name,
            columnName: col.name,
            formControlId: col.formControlId,
            formControl: col.formControlName,
            enabledInForm: true,
            enabled: col.enable,
            isDateWithTime: false,
            readOnly: false,
            childFields: [],
            ischecked: true,
            custom: true,
            dragable: true,
            isRequired : true,
            isDisabled : false,
            displayOrder: col.displayOrder,
            columnSettingId:col.columnSettingId,
            columnId: col.id,
        })),
        id: 1,
        name: 'Workbook columns',
        systemGenerated: true,
        },
    ];
  }

  mapWorkbookColumnDefinitions(columnDefinitions: ColumnDefinition[]): any[] {
    return [
        {
        customFields: [],
        fields: columnDefinitions
        .sort((a, b) => (a.displayOrder) - (b.displayOrder))
        .map((col) => ({
            id: col.id,
            intId: col.intId,
            name: col.name,
            labelName: col.name,
            field: col.name,
            columnName: col.name,
            dragable: true,
            operators: col.searchOperators,
            formControlId: col.formControlId,
            formControl: col.formControlName,
            fieldDataType: col.dataType,
            enabledInForm: true,
            enabled: col.enable,
            isDateWithTime: false,
            displayOrder: col?.displayOrder || col?.order,
            readOnly: false,
            childFields: [],
            ischecked: true,
            custom: true,
            isRequired : false,
            isDisabled : false,

        })),
        id: 1,
        name: 'Workbook columns',
        systemGenerated: true,
        },
    ];
  }

  getDynamicFormsByWorkbookID(workBookId: string) {
    this.appMainService.isShowSpinner('getDynamicFormsByWorkbookID');
    this.dynamicTableService.getDynamicFormsByWorkbookID(workBookId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('getDynamicFormsByWorkbookID');
        this.dynamicFormData= response;
        this.updateDynamicFormsLinks(this.dynamicFormData);
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getDynamicFormsByWorkbookID');
      }
    })
  }

  updateDynamicFormsLinks(data: any[]) {
    this.formLinks = [];
    const formLinks = data.map(form => ({
      label: form.name,
      items: [
        this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite && {
          label: 'Settings',
          icon: 'pi pi-cog',
          command: () => {
            this.openExistingDynamicForm(form.formId);
          }
        },
        this.selectedWorkbook?.permissionType >= WBPermissionType.AllAccess && {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.deleteDynamicForm(form.formId);
          }
        },
        this.selectedWorkbook?.permissionType >= WBPermissionType.Read && {
          label: 'Copy Link',
          icon: 'pi pi-copy',
          command: () => {
            this.copySharableLink(form.formId);
          }
        }
      ].filter(Boolean) // Remove null items
    }));
    this.formLinks.unshift(...formLinks);
    const createFormMenu = {
      label: "Add New Form",
      icon: "pi pi-plus-circle",
      command: () => {
        this.openNewDynamicForm(); // Function to add a new form
      }
    }
     if (this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite) {
      this.formLinks.push(createFormMenu);
     }
    this.updateTabListMenu();
    this.setupContextMenu();
  }
  updateTabListMenu() {
    this.tabList = [];

    if (this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite) {
      this.tabList.push(
        {
          label: 'Add Column',
          icon: 'pi pi-plus',
          command: () => {
            this.openAddColumnDialog();
          }
        },
        {
          label: 'Add Row',
          icon: 'pi pi-plus',
          command: () => {
            this.addRow();
          }
        },
      );
    }
    if (this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite) {
      this.tabList.push({
        label: 'Import',
        icon: 'pi pi-download',
        command: () => {
          this.displayImport = true;
        }
      });
    }
    if (this.selectedWorkbook?.permissionType >= WBPermissionType.Read) {
      this.tabList.push({
        label: 'Export',
        icon: 'pi pi-upload',
        command: () => {
          this.openExportWorkbook();
        }
      });
    }
    if (this.selectedWorkbook?.permissionType === WBPermissionType.AllAccess) {
      this.tabList.push(
        {
          label: 'Delete Rows',
          icon: 'pi pi-trash',
          command: () => this.openBulkDeleteDialog(),
        }
      )
    } 
    if (this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite) {
      this.tabList.push(
        {
          label: 'Convert to Other Module',
          icon: 'pi pi-sync',
          command: () => {
            this.convertToOtherModuleObject(false);
          }
        },
        {
          label: 'Move Row',
          icon: 'pi pi-forward',
          command: () => {
            this.moveToOtherWorkbook(false);
          }
        },
        {
          label: 'Copy Row',
          icon: 'pi pi-copy',
          command: () => {
            this.copyToOtherWorkbook(false);
          }
        },
        {
          label: 'Duplicate Row',
          icon: 'pi pi-copy',
          command: () => {
            this.createDuplicateRow(false);
          }
        },
        {
          label: 'Settings',
          icon: 'pi pi-cog',
          command: () => {
            this.showWBColumnSettings();
          }
        });
    }
    this.buildMenu();
  }

  copySharableLink(formID) {
    const baseUrl = window.location.origin;
    this.shareLink = `${baseUrl}/form/${this.dynamicTableData.id}/${formID}`;
    navigator.clipboard.writeText(this.shareLink).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Link copied to clipboard' });
    });

  }

  deleteDynamicForm(formId) {
    this.confirmationService.confirm({
      key: 'workbookdialog',
      message: 'Do you want to delete this Form?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteDynamicForm');
        this.dynamicTableFormService.deleteDynamicForm(formId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
          next: () => {
            this.appMainService.isHideSpinner('deleteDynamicForm');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Form deleted successfully',
            });
            this.getDynamicFormsByWorkbookID(this.workbookId);
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteDynamicForm');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.Message || 'Failed to delete Form',
            });

          }
        });
      },
      reject: () => { },
    });
  }

  updateColumnFrozen(menu, col) {
    const isFrozen = col.isFrozen;
    const workbookColumns = this.sortFrozenColumns(this.workbookColumns);
    this.workbookColumns = structuredClone(workbookColumns);
    this.updateWorkbookColumnfrozen(col.id, isFrozen)
    menu.hide();
  }

  onColReorder(event){
   const { dragIndex, dropIndex, columns} = event;
   const { dragColumn, dropColumn } = this.getColumnByDragDropIndex(dragIndex, dropIndex, columns);
   const editColumnOrderPayload: EditColumnOrderPayload = {
      id: dropColumn.id,
      workBookId: this.workbookId,
      currentOrder: dropColumn.order,
      newOrder: event.dropIndex,
    };
   this.updateWorkbookColumnOrder(editColumnOrderPayload);
  }

  getColumnByDragDropIndex(dragIndex: number, dropIndex: number, columns: any[]): { dragColumn: any; dropColumn: any } {
    const nonFrozenColumns = columns.filter((col) => !col.isFrozen);
    const dragColumn = nonFrozenColumns[dragIndex];
    const dropColumn = nonFrozenColumns[dropIndex];
    return { dragColumn, dropColumn };
  }

  createWorkbookColumn(newColumn: any) {
    this.appMainService.isShowSpinner('createWorkbookColumn');
    this.dynamicTableService.createWorkbookColumn(newColumn).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      {
        next: (response: any) => {
          this.appMainService.isHideSpinner('createWorkbookColumn');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Column created successfully!' });
          this.columnForm && this.columnForm.reset();
          this.initializeComponent();
        },
        error: (error) => {
          this.appMainService.isHideSpinner('createWorkbookColumn');
          this.columnForm && this.columnForm.reset();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to create column!' });
        }
      },
    );
  }

  updateWorkbookColumn(columnId: string, updatedColumn: any) {
    this.appMainService.isShowSpinner('updateWorkbookColumn');
    this.dynamicTableService.updateWorkbookColumn(columnId, updatedColumn).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      {
        next: (response: any) => {
          this.appMainService.isHideSpinner('updateWorkbookColumn');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Column updated successfully!' });
          this.columnForm.reset();
          this.initializeComponent();
          this.deletedColumnOptions = [];
        },
        error: (error) => {
          this.appMainService.isHideSpinner('updateWorkbookColumn');
          this.columnForm.reset();
          this.deletedColumnOptions = [];
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to update column!' });
        }
      },
    );

  }

  deleteWorkbookRow(worbookId: string, rowNumber: number) {
    this.confirmationService.confirm({
      key: 'workbookdialog',
      message: 'Do you want to delete this Row?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteWorkbookRow');
        this.dynamicTableService.deleteWorkbookRow(worbookId, rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
          next: () => {
            this.appMainService.isHideSpinner('deleteWorkbookRow');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Row deleted successfully',
            });
            this.initializeComponent();
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteWorkbookRow');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.Message || 'Failed to delete Row',
            });

          }
        });
      },
      reject: () => { },
    });
  }
  deleteWorkbookColumn(menu: any, column: any) {
    // Hide the menu
    menu.hide();

    // First, check if the column is associated with a widget
    this.dynamicTableService.checkWorkbookWidgetMapping(this.workbookId, column.id).pipe(
      takeUntil(this.ngUnsubscribe$)
    ).subscribe({
      next: (response) => {
        if (response === true) {
          // If the column is associated with a widget, show an error message
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'This column cannot be deleted as it is associated with a list.',
          });
        } else {
          // If the column is not associated with a widget, proceed to delete
          this.confirmationService.confirm({
            key: 'workbookdialog',
            message: 'Do you want to delete this Column?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
              this.appMainService.isShowSpinner('deleteWorkbookColumn');
              this.dynamicTableService.deleteWorkbookColumn(column.id).pipe(
                takeUntil(this.ngUnsubscribe$)
              ).subscribe({
                next: () => {
                  this.appMainService.isHideSpinner('deleteWorkbookColumn');
                  this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Column deleted successfully',
                  });
                  this.initializeComponent();
                },
                error: (error) => {
                  this.appMainService.isHideSpinner('deleteWorkbookColumn');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message || 'Failed to delete Column',
                  });
                }
              });
            },
            reject: () => { },
          });
        }
      },
      error: (error) => {
        // Handle error for the checkWorkbookWidgetMapping API call
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to check widget mapping',
        });
      }
    });
  }

  updateWorkbookColumnfrozen(columnId: string, isFrozen: boolean) {
    this.dynamicTableService.updateWorkbookColumnFrozen(columnId, isFrozen).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Column updated successfully!' });
        // this.initializeComponent();
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update column!' });
      }
    );
  }

  updateWorkbookColumnOrder(editColumnOrderPayload: EditColumnOrderPayload): void {
    this.dynamicTableService.updateWorkbookColumnOrder(editColumnOrderPayload)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Column order updated successfully!',
          });
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update column order!',
          });
        }
      });
  }


  pageChange(event) {
    this.pageSize = event.rows;
    // this.pageNumber= event
    this.pageNumber = ((event?.first ?? 0) / (event?.rows ?? 1)) + 1;
  }

  getTableWithPagination(event: LazyLoadEvent, fromUpdateSettings: boolean = false) {
    this.pageSize = event?.rows ?? 0;
    this.pageNumber = ((event?.first ?? 0) / (event?.rows ?? 1)) + 1;
    if (this.workbookColumns?.length > 0) {
      if (this.isGrouped) {
        this.getGroupByDynamicTable()
      }
      else {
        this.getFilteredDynamicTable();
      }
    }
  }

      //#region autonumber

    characterOnly(event): boolean {
        const character = (event.which) ? event.which : event.keyCode;
        if (character === 32) {
            return false; // Prevent space character
        }
        if (
            (character >= 65 && character <= 90) || // Uppercase letters
            (character >= 97 && character <= 122) || // Lowercase letters
            (character >= 33 && character <= 47) || // Special characters
            (character >= 58 && character <= 64) || // Special characters
            (character >= 91 && character <= 96) || // Special characters
            (character >= 123 && character <= 126) // Special characters
        ) {
            return true;
        }
        return false;
    }

    //#endregion


  updateColumn(col) {
    if (!this.columnForm.valid) {
      this.columnForm.markAllAsTouched();
      this.formErrorHandler.showErrorOnSubmit();
      return;
    }
    if(this.deletedColumnOptions.length > 0){
      this.columnForm.markAsDirty();
    }
    if (this.columnForm.valid && (this.columnForm.dirty || this.columnForm.touched)) {
      const formValue = this.columnForm.value;
      let selectedFormControlId: any
      if (formValue?.formControlName?.id) {
        selectedFormControlId = this.dataTypes.find((data) => data.id == formValue.formControlName.id);
      } 
      const updatedColumn = this.getEditPayload(col, selectedFormControlId)
       if(this.statusBarData?.isStepBarEnabled && this.statusBarData?.columnId === col.id &&  col.formControlId === FormControlListIds.DropDownList && selectedFormControlId?.id !== FormControlListIds.DropDownList){
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'This column is associated with stepbar. Changing the datatype will disable the stepbar.' });
        this.saveWorkBookColumnSettings(col.id, updatedColumn);
        return;
      }
      if(this.deletedColumnOptions.length > 0){
        this.confirmationService.confirm({
          key: 'workbookdialog',
          message: 'Do you want to delete options?',
          header: 'Delete Confirmation',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.updateWorkbookColumn(col.id, updatedColumn);
          },
          reject: () => {
            return;
          },
        });
      }
      else{
        this.updateWorkbookColumn(col.id, updatedColumn);
      }
      this.displayEditColumn = false;
      this.columnMenuIndex = 1;
      // menu.hide();
    }
    else{
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No changes have been made.' });
    }
  }

  // Build the updated payload for edit mode
  getEditPayload(curCol, selectedFormControlId:any): any {
    const formValue = this.columnForm.value;
    const existingOptions = formValue.updateOptions || [];
    const newOptions = formValue.options || [];
    const formcontrolId = selectedFormControlId ? selectedFormControlId?.id : formValue.formControlId

    const payload: any = {
      name: formValue.name,
      order: curCol.order,
      formControlId: formcontrolId,
    };
    if(selectedFormControlId?.id===FormControlListIds.AutoNumber){
      payload.prefix = formValue.prefix || '';
      payload.startNumber = formValue.startNumber;
      // payload.endingSequenceNumber = formValue.endingSequenceNumber;
    }
    else if(selectedFormControlId?.id===FormControlListIds.Barcode){
      payload.type = formValue.type;
    }
    else if(selectedFormControlId?.id===FormControlListIds.Currency){
      payload.currencyId = formValue.currencyId;
    }
    else if(selectedFormControlId?.id===FormControlListIds.Formula){
      payload.expression = formValue.expression;
    }
    else if(selectedFormControlId?.id===FormControlListIds.Decimal){
      payload.maxDecimalPlaces = formValue.maxDecimalPlaces;
    }
    else if(selectedFormControlId?.id===FormControlListIds.EncryptedText){
      payload.displayLength = formValue.displayLength;
    }

    //Add existingOptions in payload for dropdown
    if (existingOptions?.length > 0 && [FormControlListIds.DropDownList,FormControlListIds.MultipleDropDownList,FormControlListIds.RadioButton,FormControlListIds.CheckBox].includes(selectedFormControlId?.id)) {
      payload.updateOptions = existingOptions
        .map(option => ({
          id: option.id,
          option: option.option,
          color: option.color,
          order: option.order
        }));
    }
    //Add newOptions in payload for dropdown
    if (newOptions.length > 0 && [FormControlListIds.DropDownList,FormControlListIds.MultipleDropDownList,FormControlListIds.RadioButton,FormControlListIds.CheckBox].includes(selectedFormControlId?.id)) {
      payload.options = newOptions.map(option => ({
        option: option.option,
        color: option.color,
      }));
    }

    if(this.deletedColumnOptions.length > 0){
      payload.deleteOptions = this.deletedColumnOptions;
    }
    return payload;
  }

  saveWorkBookColumnSettings(colId: string, updatedColumn: any): void {   
    const columnSettingIds = this.extractColumnSettingIds();
    
    const payload = {
        workbookId: this.workbookId,
        columnSettings: columnSettingIds.map(columnSettingId => ({
            ColumnSettingId: columnSettingId,
            fields: []
        })),
        enableStepBar: false,
        defaultViewName: this.defaultViewType,
        stepbarColumnId: colId
    };
    this.dynamicTableService.updateWorkbookColumnSettings(payload)
        .subscribe({
            next: (response) => {
              this.updateWorkbookColumn(colId, updatedColumn);
              this.displayEditColumn = false;
              this.columnMenuIndex = 1;
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not updated, please try again...'
                });
            },
        });
  }

  private extractColumnSettingIds(): number[] {
    const columnSettingIds: number[] = [];
    
    if (!this.columnSettings || !Array.isArray(this.columnSettings)) {
      return columnSettingIds;
    }

    this.columnSettings.forEach(viewSetting => {
      if (viewSetting.columnSetting && Array.isArray(viewSetting.columnSetting)) {
        viewSetting.columnSetting.forEach(columnSetting => {
          if (columnSetting.columnSettingId && !columnSettingIds.includes(columnSetting.columnSettingId)) {
            columnSettingIds.push(columnSetting.columnSettingId);
          }
        });
      }
    });

    return columnSettingIds;
} 
  updateTableHeader() {
    // Check if validation passes
    if (!this.validateName(this.tableName, 'Table Name')) {
      return;  // Don't proceed if validation fails
    }

    if (this.tableName === this.dynamicTableData?.name) {
      this.isEditHeader = false;
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Table name is unchanged.' });
      return;  // Don't proceed if the name is unchanged
    }

    // Check if API is already running
    if (this.isUpdating) {
      return;  // Prevent multiple API calls
    }

    // Set flag to indicate API call is in progress
    this.isUpdating = true;

    const updatename = {
      workspaceId: this.workspaceId,
      name: this.tableName
    };

    this.isEditHeader = false;

    // API call to update the table name
    this.dynamicTableService.updateWorkbookName(this.workbookId, updatename)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        {
          next: (response: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Table name updated successfully!' });
            this.isUpdating = false;  // Reset the flag once the API call is successful
            this.dynamicTableData.name = updatename?.name
            this.workbookPropertyChanged.emit({ isUpdate: true });
          },
          error: (error) => {
            this.tableName = this.dynamicTableData?.name;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to update name!' });
            this.isUpdating = false;  // Reset the flag if the API call fails
          }
        }
      );
  }

  validateName(name: string, fieldName: string): boolean {
    const specialCharRegex = /^[a-zA-Z0-9*@()-_#$ ]*$/;

    // Initialize error object if not already present
    if (!this.validationErrors) {
      this.validationErrors = {};
    }

    // Check if the name is blank or only has spaces
    if (!name || name.trim().length === 0) {
      this.validationErrors[fieldName] = `${fieldName} cannot be blank or contain only spaces.`;
      return false;
    }

    // Check if the name starts with a space
    if (name.startsWith(' ')) {
      this.validationErrors[fieldName] = `${fieldName} cannot start with a space.`;
      return false;
    }

    // Check if the length exceeds 100 characters
    if(fieldName === 'Table Name' && name.length > 100) {
      this.validationErrors[fieldName] = `${fieldName} should be less than 100 characters.`;
      return false;
    }
    else if(fieldName === 'Document Name' && name.length > 50) {
      this.validationErrors[fieldName] = `${fieldName} should be less than 50 characters.`;
      return false;
    }

    // Check if it contains invalid special characters
    if (!specialCharRegex.test(name)) {
      this.validationErrors[fieldName] = `${fieldName} contains invalid characters. Only @,-, _, #, $, (, ) are allowed.`;
      return false;
    }

    // If valid, clear the error
    this.validationErrors[fieldName] = '';
    return true;
  }

  // Method to patch the column form with selected column data
  patchColumnForm(column: any) {
    const selectedFormControlId: any = this.dataTypes.find((data) => data.id == column.formControlId);
    this.columnForm.patchValue({
      name: column.name,
      formControlId: selectedFormControlId.id,
      isFrozen: column.isFrozen,
      id: column.id,
      formControlName: selectedFormControlId,
      prefix: column?.prefix || null,
      startNumber: column?.startNumber ?? null,
      // endingSequenceNumber: column?.endingSequenceNumber || null,
      type: column?.type ?? null,
      expression: column?.expression ?? null,
      maxDecimalPlaces: column?.maxDecimalPlaces ?? null,
      displayLength:  column?.displayLength ?? null,
      currencyId: column?.currencyId ?? null,
    });

    this.getWorkbookColumnOptionValue(column.id).pipe(
      catchError(error => {
        return of([]);
      })
    ).subscribe(data => {
      if (data.length) {
        this.patchUpdateOptions(data);
      }
    });
  }

  // Enable editing and patch the form when the user clicks "Edit"
  openEditColumnDialog(column: any) {
    this.deletedColumnOptions = [];
    this.displayAddColumn = false; //to flush previous state
    this.initWorkbookColumnForm();
    this.patchColumnForm(column);
    this.selectedColumn = column;
    this.displayEditColumn = true;
  }

  openAddColumnDialog() {
    this.displayEditColumn = false; //to flush previous state
    this.displayAddColumn = true;
    this.initWorkbookColumnForm();
  }

  onHideAddColumn() {
    this.displayAddColumn = false;
  }
  onHideEditColumn(){
    this.displayEditColumn = false;
    this.selectedColumn = null;
  }


  openEditDialog() {
    this.mode = 'edit';
    this.currentRowNUmber = this.selectedRow?.RowNumber;
    this.formHeader = `${this.dynamicTableData?.name}: Edit Row ${this.currentRowNUmber}`;
    this.displayAddEdit = true;
  }

  openDeleteDialog() {
    this.currentRowNUmber = this.selectedRow?.RowNumber;
    this.deleteWorkbookRow(this.workbookId, this.currentRowNUmber)
  }

  onRowSelect(event) {
    this.mode = 'view'
    this.currentRowNUmber = this.selectedRow?.RowNumber;
    this.formHeader = `${this.dynamicTableData?.name}: View Row ${this.currentRowNUmber}`;
    this.displayAddEdit = true;
  }

  onRowSelectFromKanban(event) {
    this.mode = 'view'
    this.currentRowNUmber = event.RowNumber;
    this.formHeader = `${this.dynamicTableData?.name}: View Row ${this.currentRowNUmber}`;
    this.displayAddEdit = true;
  }

  onCardMoved(event: {card: any, newGroup: string, sourceGroup: string, targetStep: StepBarResponse | undefined}) {
    // this.getStatusBarData(); Need to check what should be update in listing.
    }

  addColumn() {
    if (!this.columnForm.valid) {
      this.columnForm.markAllAsTouched();
      this.formErrorHandler.showErrorOnSubmit();
      return;
    }
    const optionsPayload = this.columnForm.value.options.map((option: any) => ({
      option: option.option, // Option label
      color: option.color,    // Selected color
      order: option.order
    }));
   const formControlId = this.columnForm.value.formControlName?.id;
    let createColumn:any = {
      TableId: this.workbookId,
      name: this.columnForm.value.name,
      order: this.highestColumnOrder,
      formControlId: formControlId,
      options: optionsPayload,
    };

    if(formControlId===FormControlListIds.AutoNumber){
      createColumn.prefix = this.columnForm.value.prefix || '';
      createColumn.startNumber = this.columnForm.value.startNumber;
      // createColumn.endingSequenceNumber = this.columnForm.value.endingSequenceNumber;
    }
    else if(formControlId===FormControlListIds.Barcode){
      createColumn.type = this.columnForm.value.type;
    }
    else if(formControlId===FormControlListIds.Currency){
      createColumn.currencyId = this.columnForm.value.currencyId;
    }
    else if(formControlId===FormControlListIds.Formula){
      createColumn.expression = this.columnForm.value.expression;
    }
    else if(formControlId===FormControlListIds.Decimal){
      createColumn.maxDecimalPlaces = this.columnForm.value.maxDecimalPlaces;
    }
    else if(formControlId===FormControlListIds.EncryptedText){
      createColumn.displayLength = this.columnForm.value.displayLength;
    }

    // menu.hide();
    this.displayAddColumn = false;
    this.createWorkbookColumn(createColumn);
  }


  getWorkbookColumnOptionValue(columnId: string, query: string = ''): Observable<any[]> {
    return this.dynamicTableService.getWorkbookColumnOptionValue(columnId, query);
  }

  closeColumnMenu(menu) {
    menu.hide();
  }

  onEditComplete(event: any) {
    const { workbookRows, id } = event;
    const rowIndex = this.workbookRows.findIndex(row => row === workbookRows);
    if (rowIndex > -1) {
      this.workbookRows[rowIndex][id] = event.newValue;
    }
  }

  addRow() {
    this.mode = 'add';
    this.formHeader = `${this.dynamicTableData?.name}: Add New Row`;
    this.displayAddEdit = true;
  }

   //#region GroupBy
  applyGroup() {
    this.pageNumber = 1;
    this.pageSize = 15;
    this.totalRecords = 0;
    this.first = 0;
    this.selectedGroupByValue = structuredClone(this.selectedGroupBy);
    this.groupByColumn = {
      name: this.selectedGroupBy?.name,
      dataTypes: this.selectedGroupBy?.dataTypes
    }
    this.getGroupByDynamicTable();
    this.saveFilterDataChannalWise(this.saveFilterData);
  }

  resetGroup(reloadList: boolean = false) {
    this.selectedGroupBy = null;
    this.selectedGroupByValue = null;
    this.isEditHeader = false;
    this.isGrouped = false;
    this.resetpageState();
    this.saveFilterDataChannalWise(this.saveFilterData);
    // this.getFilteredDynamicTable()
  }

  onAllGroupExpand() {
    this.groupAllExpanded = !this.groupAllExpanded;
    this.groupWorkBookRows.map(rowData => {
      rowData['expanded'] = this.groupAllExpanded;
    });
  }

  onGroupExpand(rowData: any) {
    rowData['expanded'] = !rowData?.expanded as boolean;
  }

  expandSelectedRowGroup() {
    const groupByValue = this.selectedRow[this.selectedGroupBy.columnName];
    this.groupAllExpanded = false;
    this.groupWorkBookRows.map((rowData: any) => {
      rowData['expanded'] = (rowData.groupByValue == groupByValue) as boolean;
    })
  }

  onListPageChange(event, rowData) {
    this.rootPageSize = event?.rows ?? 0;
    this.rootPageNumber = ((event?.first ?? 0) / (event?.rows ?? 1)) + 1;
    const selectableColumns = this.workbookColumns.map(col => ({ name: col.name }));
    const filterInColumns = [...this.filterInColumns];
    if(this.stepBarFilter){     
      filterInColumns.push(this.stepBarFilter);    
    }
    // Build the final filter query object
    const filterQuery = {
      globalSearchValue: this.globalSearchValue || '',
      tableId: this.workbookId,
      pageNumber: this.rootPageNumber || 1,  // Default to first page if not specified
      pageSize: this.rootPageSize || 15,  // Default to current pageSize
      selectableColumns: selectableColumns,
      ...(filterInColumns ? { filterInColumns: filterInColumns } : {}),
      ...(this.selectedSortColumn ? { sortByColumn: this.selectedSortColumn } : {}),
      ...(this.isDescending !== undefined && this.isDescending !== null ? { isDescending: this.isDescending } : {}),
    };
    let groupValue = rowData.groupValue === null ? [""] : [rowData.groupValue];
    let operator = "IsEqualTo";
    if (!rowData.groupValue) {
      operator = "NoValue";
    }
    const selectedColumn = this.getColumnNameByID(this.selectedGroupBy?.id);
    const groupFilterData: MappedFilter = {
      name: this.selectedGroupBy?.columnName,
      dataType: selectedColumn?.formControlName,
      operator: operator,
      operationType: "AND",
      values: groupValue
    }
    const groupFilterIndex = filterQuery.filterInColumns.findIndex(filter => filter.name == this.selectedGroupBy?.columnName);

    if (groupFilterIndex >= 0) {
      filterQuery.filterInColumns[groupFilterIndex] = groupFilterData;
    } else {
      filterQuery.filterInColumns.push(groupFilterData);
    }

    this.appMainService.isShowSpinner('getFlatListDynamicTable');
    this.dynamicTableService.getFilteredDynamicTable(filterQuery).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: DynamicTableData) => {
        this.appMainService.isHideSpinner('getFlatListDynamicTable');
        this.dynamicTableData = response;
        const mappedData = this.mapRows(this.dynamicTableData.result.list);
        rowData.rowList = mappedData;
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getFlatListDynamicTable');
      }
    })

  }
//#endregion GroupBy

  //#region DynamicForm
  handleFormStatusChange(event) {
    if (this.isGrouped) {
      this.getGroupByDynamicTable();
      return;
    }
    if (event) {
      this.getFilteredDynamicTable();
    }
  }

  openNewDynamicForm() {
    this.displayDynamicForm = true;
  }

  openExistingDynamicForm(formId) {
    this.dynamicFormID = formId;
    this.displayDynamicForm = true;
  }

  handlecreatedFormEvent(event) {
    this.getDynamicFormsByWorkbookID(this.workbookId);
  }
  //#endregion DynamicForm

  //#region AddList/SubList
  addToList() {
    this.displayAddToList = true;
  }

  cancelToList() {
    this.displayAddToList = false;
  }

  viewAddedList() {
    this.displayAddedList = true;
  }

  cancelAddedList() {
    this.displayAddedList = false;
  }
  backListView() {
    this.selectedWorkbook = null;
    this.getWorkspaceItemsDetailsByID(this.workspaceId);
  }
  //#endregion  AddList/SubList

  getWorkspaceItemsDetailsByID(workspaceId) {
    this.appMainService.isShowSpinner('getWorkspaceItemsDetailsByID');
    this.workspaceService
      .getWorkspaceItemsDetailsByID(workspaceId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.appMainService.isHideSpinner('getWorkspaceItemsDetailsByID');
          this.workBookList = response;
          this.selectedWorkbook = this.getSelectedWorkbook(this.workbookId);
          this.updateTabListMenu();
          this.setupContextMenu();
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getWorkspaceItemsDetailsByID');
        },
      });
  }

  getSelectedWorkbook(workbookID: string): WorkbookList | null {
    const workbook: WorkbookList = this.workBookList.find(wb => wb.id === workbookID);
    return workbook ? workbook : null; // Return null if workbook ID not found
  }

  hideImport() {
    this.displayImport = false;
  }

    //#region Attachment/Documents
  openAttachmentsModal(event, data, rowIndex) {
    event.stopPropagation();
    this.selectedWorkbookRow = data;
    this.attachmentHeader = `Attachments: Row ${rowIndex}`;
    this.getWorkbookDocumentList(data?.RowNumber);
    this.displayAttachment = true;

  }
  onHideAttachmentModal(fileUpload) {
    this.displayAttachment = false;
    this.attachmentHeader = 'Attachments';
    this.uploadedFiles = null;
    this.selectedWorkbookRow = null;
    this.documentsList = [];
    fileUpload.clear();
  }
  onFileSelect(event, fileUpload) {
    const file: File = event.files[0];

    if (file) {
      this.uploadedFiles = file; // Store file for UI display
      const rowNumber = this.selectedWorkbookRow?.RowNumber;
      this.createRowDocument(rowNumber, file, fileUpload)
    }

  }

  getWorkbookDocumentList(rowNumber) {
    this.appMainService.isShowSpinner('getWorkbookDocumentList');
    this.dynamicTableService.getRowDocument(this.workbookId, rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('getWorkbookDocumentList');
        this.documentsList = response;
        this.uploadedFiles = null;
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getWorkbookDocumentList');
      }
    })
  }

  createRowDocument(rowNumber, file, fileUpload) {
    this.appMainService.isShowSpinner('createRowDocument');
    this.dynamicTableService.createRowDocument(this.workbookId, rowNumber, file).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('createRowDocument');
        this.getWorkbookDocumentList(rowNumber);
        fileUpload.clear();
        if(!this.isGrouped){
          this.getFilteredDynamicTable();
        }
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document uploaded successfully!' });
      },
      error: (error) => {
        this.appMainService.isHideSpinner('createRowDocument');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to upload document!' });
      }
    })
  }

  openFilePreview(event, data) {
    event.stopPropagation();
    this.previewFile(data);
  }

  downloadAttachmentFile(data, event?) {
    if(event){
      event.stopPropagation();
    }
    this.appMainService.isShowSpinner('downloadFile');
    this.dynamicTableService.downloadDocument(this.workbookId, this.selectedWorkbookRow?.RowNumber, data.attachmentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: WbAttachmentsDownload) => {
        this.appMainService.isHideSpinner('downloadFile');
        const fileUrl = response?.downloadLink; // Replace with your API's file URL field
        if (fileUrl) {
          window.open(fileUrl, '_blank'); // Open the file in a new tab
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document Download successfully!' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('downloadFile');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
      }
    })

  }
  closeFilePreview() {
    this.displayFilePreview = false;
  }

  previewFile(data) {
    this.appMainService.isShowSpinner('previewFile');
    this.dynamicTableService.downloadDocument(this.workbookId, this.selectedWorkbookRow?.RowNumber, data?.attachmentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: WbAttachmentsDownload) => {
        this.appMainService.isHideSpinner('previewFile');
        const fileUrl = response?.downloadLink;
        if (fileUrl) {
          const extension = data?.extension?.replace('.', '').replace(/\s+/g, '') || '';
          this.documentViewerService.previewDocument(extension, response);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('previewFile');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
      }
    })
  }


  buildDocumentContextMenu() {
    this.documentCMItems = [];

    // View - Available from Read & above
    if (this.selectedWorkbook?.permissionType >= WBPermissionType.Read) {
      this.documentCMItems.push({
        label: 'View',
        icon: 'pi pi-eye',
        command: () => this.previewFile(this.selectedDocument),
      });
    }

    // Edit - Available from ReadWrite & above
    if (this.selectedWorkbook?.permissionType >= WBPermissionType.ReadWrite) {
      this.documentCMItems.push({
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => this.openEditDocument(this.selectedDocument),
      });
    }

    // Delete - Available only for AllAccess
    if (this.selectedWorkbook?.permissionType === WBPermissionType.AllAccess) {
      this.documentCMItems.push({
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => this.deleteDocument(this.selectedDocument),
      });
    }

    // Download - Available from Read & above
    if (this.selectedWorkbook?.permissionType >= WBPermissionType.Read) {
      this.documentCMItems.push({
        label: 'Download',
        icon: 'pi pi-download',
        command: () => {
          this.downloadAttachmentFile(this.selectedDocument);
        }
      });
    }
  }

  deleteDocument(selectedDocument: WbAttachmentsDocument) {
    this.confirmationService.confirm({
      key: 'workbookdialog',
      message: 'Do you want to delete this Document?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteDocument');
        this.dynamicTableService.deleteRowDocument(this.workbookId, this.selectedWorkbookRow?.RowNumber, selectedDocument.attachmentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
          next: (response: any) => {
            this.appMainService.isHideSpinner('deleteDocument');
            this.getWorkbookDocumentList(this.selectedWorkbookRow?.RowNumber);
            if(!this.isGrouped){
              this.getFilteredDynamicTable();
            }
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully!' });
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteDocument');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to delete document!' });
          }
        })
      },
      reject: () => { },
    });


  }

  openEditDocument(data, event?) {
    if(event){
      event.stopPropagation();
    }
    this.tempDocument = data;
    this.tempDocumentName = data.name.split('.').slice(0, -1).join('.');;
    this.displayEditDocument = true;
  }

  editDocumentName(tempDocumentName){
        // Check if validation passes
        if (!this.validateName(tempDocumentName, 'Document Name')) {
          return;  // Don't proceed if validation fails
        }

        // Check if API is already running
        if (this.isUpdating) {
          return;  // Prevent multiple API calls
        }
        const documentName = this.tempDocumentName.replace(/\s+/g, ''); // Remove all spaces
      // Extract the base name (without extension) from the existing document name
        const existingBaseName = this.tempDocument.name.split('.').slice(0, -1).join('.');

        // Check if the updated name matches the existing name
        if (documentName === existingBaseName) {
          this.validationErrors['Document Name'] = 'Name cannot be the same as the existing name';
          return;
        }
        const wbEditAttachmentsPayload:WbEditAttachmentsPayload = {
          attachmentId: this.tempDocument.attachmentId,
          name: documentName
        }
        // Set flag to indicate API call is in progress
        this.isUpdating = true;
    this.appMainService.isShowSpinner('editDocument');
    this.dynamicTableService.updateRowDocument(this.workbookId, this.selectedWorkbookRow?.RowNumber, wbEditAttachmentsPayload).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.isUpdating = false;
        this.appMainService.isHideSpinner('editDocument');
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document name updated successfully!' });
        this.tempDocument = null;
        this.tempDocumentName = '';
        this.displayEditDocument = false;
        this.getWorkbookDocumentList(this.selectedWorkbookRow?.RowNumber);
      },
      error: (error) => {
        this.isUpdating = false;
        this.appMainService.isHideSpinner('editDocument');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to update document!' });
      }
    })
  }

  onHideEditDocument(){
    this.tempDocument = null;
    this.tempDocumentName = '';
    this.displayEditDocument = false;
    this.validationErrors = '';
  }
  //#end Attachment/Documents

  //#region RowLevelComments

  openCommentsModal(event, workbookRow, rowIndex) {
    event.stopPropagation();
    this.selectedWorkbookRow = workbookRow;
    if (workbookRow.noOfUnreadComments > 0) {
      workbookRow.noOfUnreadComments = 0;
      this.updateReadStatus = true;
    }
    this.selectedWorkbookRow['rowIndex'] = rowIndex;
    this.displayComments = true;
  }

  onHideCommentsModal() {
    this.displayComments = false;
    this.updateReadStatus = false;
    this.selectedWorkbookRow = null;
  }
    //#end RowLevelComments

  //#region Workbook Reminder
  openReminderModal(event, workbookRow, rowIndex) {
    event.stopPropagation();
    this.workbookReminderProps = {
      objectId: workspaceModuleId,
      channelId: this.workbookId,
      objectRecordId: workbookRow.RowNumber,
      rowIndex: rowIndex,
    }
    this.displayReminder = true;
  }

  reminderUpdateStatus(isUpdate) {
    if (isUpdate && !this.isGrouped) {
      this.getFilteredDynamicTable();
    }
  }

  onHideReminderModal() {
    this.displayReminder = false;
    this.workbookReminderProps = null;
  }
  //#end WorkbookReminder

  //#region workbook export
  openExportWorkbook(): void {
    this.displayExport = true;
  }

  onExportCompleted(): void {
    this.displayExport = false;
  }
  //#endregion

  getFileIcon(fileName: string): string {
    const seperationIndex = fileName.lastIndexOf(".");
    const extension = fileName.substring(seperationIndex + 1).toLowerCase();
    return `${environment.assestsBasePath}icons/${extension}.png`;
  }

  //#region Save&RetainFilterData
  saveFilterDataChannalWise(selectedColumns?: SavedFilterData) {
    let filterLines: FilterLine[] = selectedColumns.filter.map((column: any) => {
      return {
        columnId: column.fieldId,
        operator: column.operator,
        operationType: column.operationType,
        values: [...(column?.values || [])],
      };
    });
    this.appMainService.isShowSpinner('saveFilterDataChannalWise');
    let requestBody: RetainSavedFilterData = {
      workbookId: this.workbookId,
      groupByColumnId: this.selectedGroupByValue?.id ?? null,
      filterLines: filterLines
    }

    this.dynamicTableService.retainSavedFilterData(requestBody).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('saveFilterDataChannalWise');
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when saving filter data. Please try after sometime.'
        });
        this.appMainService.isHideSpinner('saveFilterDataChannalWise');
      }
    });
  }

  getFilterData() {
    this.appMainService.isShowSpinner('getFilterData');
    this.dynamicTableService.getSavedFilterData(this.workbookId).subscribe({
      next: (data: RetainSavedFilterData) => {
        if (data) {
          this.saveFilterData = structuredClone(this.mapFilterData(data));
          this.filterInColumns = data?.filterLines.map((filteredData) => {
            const selectecdColumn: any = this.getColumnNameByID(filteredData?.columnId);
            let field: MappedFilter = {
              name: selectecdColumn?.name,
              operator: filteredData?.operator,
              operationType: filteredData?.operationType,
              values: filteredData?.values,
              dataType: selectecdColumn?.formControlName
            }
            if (filteredData.operator == "On" || filteredData.operator == "NotOn") {
              field.values = [];
              field = this.dateOnOperatorListValue(filteredData, field);
            } else {
              field.values = filteredData?.values;
            }
            return field;
          })

          //For Group By
          if (this.saveFilterData?.groupByFieldId) {
            this.selectedGroupBy = this.mappedColFilter.find((item) => {
              return item?.id == this.saveFilterData?.groupByFieldId;
            });
            this.groupByColumn = {
              name: this.selectedGroupBy?.name,
              dataTypes: this.selectedGroupBy?.dataTypes
            }
            this.isGrouped = !!this.saveFilterData?.groupByFieldId;
            this.selectedGroupByValue = structuredClone(this.selectedGroupBy);
          }
          if (this.isGrouped) {
            this.getGroupByDynamicTable();

          } else {
            this.getFilteredDynamicTable();
          }
        }
        this.appMainService.isHideSpinner('getFilterData');
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when getting filter data. Please try after sometime.'
        });
        this.appMainService.isHideSpinner('getFilterData');
      },
    })
  }

  getColumnNameByID(columnID: string): any {
    return this.workbookColumns.find(col => col.id == columnID);
  }

  mapFilterData(data: any): any {
    return {
      groupByFieldId: data.groupByColumnId,
      groupByColumnName: data.groupByColumnId ? this.getColumnNameByID(data.groupByColumnId)?.name || null : null,
      filter: data.filterLines.map((filterLine: any) => {
        const column = this.getColumnNameByID(filterLine.columnId);
        return {
          fieldId: filterLine.columnId,
          name: column?.name || null,
          displayName: column?.name || null,
          operator: filterLine.operator,
          operationType: filterLine.operationType,
          values: [...(filterLine?.values || [])],
          isCustom: true,
          filterValues: []
        };
      })
    };
  }

  //#endregion Save&RetainFilterData
  //#region ColumnSettings
  showWBColumnSettings(): void {
    const wbColumnSetting = this.mapWorkbookColumnSettings(this.workbookColumns);
    // const kanbanViewColumnSetting = this.columnSettings.find(col => col.viewType==='KanbanView');
    // const kanbanViewFlatList = this.getColumnSettingFlatList(kanbanViewColumnSetting?.columnSetting);
    const kanbanViewSections =  this.mapWorkbookColumnSettings(this.kanbanViewColumns);
    // this.displaySettings = true;
    this.columnSettingsN = {
      moduleId: workspaceModuleId,
      // channelId: this.workspaceId,
      displayStepBar: this.statusBarData?.isStepBarEnabled,
      defaultViewType: this.defaultViewType==='KanbanView'?2:1,
      listViewSections: wbColumnSetting,
      kanbanViewSections: kanbanViewSections,
      detailsViewSections: [],
    }
    this.displayColumnSettings = true;
  }

  savedColumnSettings(): void {
    this.displayColumnSettings = false;
    this.fromUpdateSettings = false;
    this.statusBarData = null;
    this.steps = [];
    this.columnSettings= null;
    this.kanbanViewColumns = [];
    this.initializeComponent();
    // this.getColumnSettings(true);
  }

  cancelColumnSettings(): void {
    this.displayColumnSettings = false;
    this.fromUpdateSettings = false;
  }
//#endregion ColumnSettings

    //#region add/edit expression

    loadExpressionAvailableFields(openAddExpression: boolean = true) {
      this.availableFieldsForExpression = this.workbookColumns.filter(field=> [FormControlListIds.Number,FormControlListIds.Decimal,FormControlListIds.Currency,FormControlListIds.Percentage].includes(field.formControlId));
      this.availableFieldsForExpression.map(field=>{
          field['labelname'] = field.name;
          field['field'] = field.name;
      });

      if(openAddExpression){
          this.openExpressionAdd();
      }

  }

    openExpressionAdd(){
      this.expressionText = this.columnForm.value.expression||"";
      this.displayAddExpression = true;
  }

  saveExpression(expressionData: {expressionText: string, addedFieldTags: string[]}){
      this.columnForm.patchValue({
          expression: expressionData.expressionText
      });
      this.columnForm.get('expression')?.markAsDirty();
      this.columnForm.get('expression')?.markAsTouched();
  }

  removeExpression(){
      this.columnForm.patchValue({
          expression: ''
      });
  }

  expressionDialogClose(){
      this.displayAddExpression = false;
  }
  //#endregion
  //#region Tagged User Details Popup
  openTaggedUserDetails(event, userId: any) {
    event.stopPropagation();
    this.selectedUser = userId;
    this.displayUserDetails = true;
  }
  closeTaggedUserDetails(){
    this.selectedUser = null;
    this.displayUserDetails = false;
  }
  //#endregion Tagged User Details Popup


  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  //files and pics
  openFiles(e, files) {
    e.stopPropagation();
    this.displayType = 'files';
    this.displayItems = files;
    this.displayFileDialog = true;
  }

  openPics(e, pics) {
    e.stopPropagation();
    this.displayType = 'pics';
    this.displayItems = pics;
    this.displayFileDialog = true;
  }

  onDisplayDialogChange(value: boolean) {
    this.displayFileDialog = value;
    if (!value) {
      this.displayItems = [];
    }
  }

  //#region convert to different module
  convertToOtherModuleObject(isSelectedRow: boolean= false) {
    if(!isSelectedRow){
      this.selectedRow = null;
    }
    this.displayConvertToDifferentModule = true;
  }

  moveToOtherWorkbook(isSelectedRow: boolean= false) {
    if(!isSelectedRow){
      this.selectedRow = null;
    }
    this.displayConvertToDifferentModule = true;
    this.isCopyMoveWBRow = true;
    this.isMoveWBRow = true;
  }
  copyToOtherWorkbook(isSelectedRow: boolean= false) {
    if(!isSelectedRow){
      this.selectedRow = null;
    }
    this.displayConvertToDifferentModule = true;
    this.isCopyMoveWBRow = true;
    this.isCopyWBRow = true;
  }
  createDuplicateRow(isSelectedRow: boolean= false) {
    if(!isSelectedRow){
      this.selectedRow = null;
    }
    this.displayConvertToDifferentModule = true;
    this.isCopyMoveWBRow = true;
    this.isCreateDuplicateRow = true;
  }
  onHideconvertToOtherModuleObject(event) {
     this.displayConvertToDifferentModule = false;
      this.isCopyMoveWBRow = false;
      this.isMoveWBRow = false;
      this.isCopyWBRow = false;
      this.isCreateDuplicateRow = false;
  }
  //#end convert to different module

  //#region dynamic charts
  displayDynamicCharts: boolean = false;

  showDynamicCharts(){
    this.displayDynamicCharts = true;
  }

  closeDynamicCharts(){
    this.displayDynamicCharts = false;
  }
  //#endregion


  public dateOnOperatorListValue(data: {
      name?: string;
      value?: string;
      operator: string;
      operationType?: string;
      values?: string[];
      isCustom?: boolean;
      fieldId?: number;
    }, field: MappedFilter) {
  
      const dateRange = filterDateRangeHelper(data?.values[0]);
      let dateRangeFrom: Date | null = dateRange?.dateRangeFrom;
      let dateRangeTo: Date | null = dateRange.dateRangeTo;
  
      if ((dateRangeFrom && dateRangeTo)) { 
        const fieldDetails = this.mappedColFilter.find(fld => fld?.columnName == data?.name);
        field.operator = data.operator == 'NotOn' ? 'NotBetween' : 'Between';
         dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (fieldDetails?.isDateWithTime || false), true, !['This Month', 'Last Month'].includes(data?.values[0]));
         dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (fieldDetails?.isDateWithTime || false), true, !['This Month', 'Last Month'].includes(data?.values[0]));
        dateRangeTo.setDate(dateRangeTo.getDate() + 1);
        dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
        field.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom), this.timeZoneService._getUTCDateTimeString(dateRangeTo));
      } else if (data.values?.[0]) {
        field.operator = data.operator == 'NotOn' ? 'NotBetween' : 'Between';
        field.values.push(data.values?.[0], data.values?.[0])
      }
  
      return field;
    }
  
    switchView(viewType: 'ListView' | 'KanbanView') {
      this.viewType = viewType;
      if (viewType === 'KanbanView') {
        // Initialize Kanban view settings if not already set
        if (!this.kanbanGroupByColumn && this.workbookColumns.length > 0) {
          // Try to find a suitable column for grouping (e.g., status, type, etc.)
          const potentialGroupColumns = this.workbookColumns.filter(col => 
            ['DropDownList', 'UserLookup'].includes(col.formControlName)
          );
          if (potentialGroupColumns.length > 0) {
            this.kanbanGroupByColumn = potentialGroupColumns[0].name;
          }
        }
        if (!this.kanbanCardTitleColumn && this.workbookColumns.length > 0) {
          // Use the first text column as card title
          const titleColumn = this.workbookColumns.find(col => 
            ['InputBox', 'TextArea'].includes(col.formControlName)
          );
          if (titleColumn) {
            this.kanbanCardTitleColumn = titleColumn.name;
          }
        }
        if (this.kanbanCardContentColumns.length === 0 && this.workbookColumns.length > 0) {
          // Add a few relevant columns as card content
          this.kanbanCardContentColumns = this.workbookColumns
            .filter(col => !['DropDownList', 'UserLookup'].includes(col.formControlName))
            .slice(0, 3)
            .map(col => col.name);
        }
      }
    }

  

  /**
   * Set default view type for the workbook
   */

  setDefaultViewType(viewType: 'ListView' | 'KanbanView'){
    this.defaultViewType = viewType;
    this.viewType = viewType;
    this.switchView(viewType as 'ListView' | 'KanbanView');
  }

  /**
   * Set status bar data for the workbook
   */


  onStepSelected(step: any) {
    // this.resetpageState();
    this.rootPageNumber = 1;
    this.rootPageSize = 15;
    this.pageNumber = 1;
    this.pageSize = 15;
    this.totalRecords = 0;
    this.first = 0;
    this.table.first = 0;
    this.stepBarFilter = null;
    if(step?.id){
      const filterInColumns = {
        name: this.statusBarData?.columnName, 
        dataType: "DropDownList",
        operationType: "AND",
        operator: step?.name ? "IsEqualTo" : "NoValue",
        values: [
          step.name ||""
        ]
      }
      this.stepBarFilter = {...filterInColumns};  
    }
    else if(step?.id===null && step?.value==null){
      const filterInColumns = {
        name: this.statusBarData?.columnName, 
        dataType: "DropDownList",
        operationType: "AND",
        operator: "NoValue",
        values: [""]
      }
      this.stepBarFilter = {...filterInColumns};  
    }
    this.getFilteredDynamicTable();
  } 

  loadStepBar(stepBarList: any){
    if (stepBarList && stepBarList.length > 0) {
      const mappedSteps = stepBarList.map(step => ({
        ...step,
        name: step?.value || 'NA',
        count: step?.count || 0,
        stageColor: step?.color ||'#A0D683',
        color: step?.value ? step?.textColor : '#FFFFFF',
        order: step?.order || 0
      }));

      this.steps = mappedSteps.sort((a, b) => {
        if (!a.value && a.count && b.value) return 1;
        if (a.value && !b.value && b.count) return -1;
        return 0;
      });
    } else {
      this.steps = [];
    }
  }

  onOptionsReorder(event: CdkDragDrop<any[]>, isUpdateOptions: boolean = false) {
    if (this.columnForm.get('formControlName')?.value?.name === 'DropDownList' || 
        this.columnForm.get('formControlName')?.value?.name === 'MultipleDropDownList' ||
        this.columnForm.get('formControlName')?.value?.name === 'CheckBox' ||
        this.columnForm.get('formControlName')?.value?.name === 'RadioButton') {
      
      const optionsArray = isUpdateOptions ? this.updateOptions : this.options;
      moveItemInArray(optionsArray.controls, event.previousIndex, event.currentIndex);
      // Update the order numbers
      optionsArray.controls.forEach((control, index) => {
        control.patchValue({
          order: index + 1
        });
      });
      // Mark the form as dirty since we reordered options
      this.columnForm.markAsDirty();
      this.columnForm.updateValueAndValidity();
    }
  }

  hideSideNavigation(){
    this.isShowSideBtn = !this.isShowSideBtn;
    this.forceReflow = !this.forceReflow;
    this.isChangeSideBtn.emit(this.isShowSideBtn);
  }

  //#region Bulk Delete
  openBulkDeleteDialog() {
    this.displayBulkDelete = true;
  }

  closeBulkDelete() {
    this.displayBulkDelete = false;
  }

  resetSelection() {
    this.sharedWorkbookListing.resetSelection();
  }

  saveBulkDelete() {
    this.sharedWorkbookListing.saveSelection();
    const selectedRows = [...this.sharedWorkbookListing.selectedRowForConversion];
    if (!selectedRows?.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select at least one row to delete'
      });
      return;
    }

    this.confirmationService.confirm({
      key: 'workbookdialog',
      message: `Are you sure you want to delete ${selectedRows.length} selected row${selectedRows.length > 1 ? 's' : ''}?`,
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.appMainService.isShowSpinner('saveBulkDelete');
        const rowNumbers = selectedRows.map(row => row.rowNumber);
        const payload = {
          rowNumbers: rowNumbers,
        }
        this.dynamicTableService.deleteWorkbookRows(this.workbookId, payload)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe({
            next: () => {
              this.appMainService.isHideSpinner('saveBulkDelete');
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `${selectedRows.length} row${selectedRows.length > 1 ? 's' : ''} deleted successfully`
              });
              this.closeBulkDelete();
              this.handleFormStatusChange(true);
            },
            error: (error) => {
              this.appMainService.isHideSpinner('saveBulkDelete');
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.Message || 'Failed to delete selected rows'
              });
            }
          });
      }
    });
  }
  //#endregion  
}
